import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SapiPrice } from '../models/amazon';
import { AmazonItemSearch } from '../models/amazon-item-search';
import { BaseHttpService } from '../auth/base-capacitor-http';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface EbayToken{
  access_token: string;
  expires_in: number;
  token_type: string;
}
@Injectable({
  providedIn: 'root'
})
export class AmazonService extends BaseHttpService{

  private baseUrl: string = environment.server.mainURL;
  private urlEndPoint: string;
 
  constructor(client: HttpClient, snackBar:MatSnackBar) {
    super(client, snackBar);
  }

   async getSapiItemListResult(type: string, search: string): Promise<AmazonItemSearch> {
      this.urlEndPoint = this.baseUrl + 'sapi-item-search/' + type + '/' + search;
      return this.get<AmazonItemSearch>(this.urlEndPoint);
   }

   async getSapiPrices(asin: string): Promise<SapiPrice>{
      this.urlEndPoint = this.baseUrl + 'sapi-prices/' + asin;
      return this.get<SapiPrice>(this.urlEndPoint);
   }

   
}
